var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.237 1.65a9.589 9.589 0 00-3.03 18.683c.478.09.654-.208.654-.46 0-.23-.009-.985-.013-1.786-2.667.58-3.23-1.13-3.23-1.13-.436-1.109-1.064-1.403-1.064-1.403-.87-.595.065-.583.065-.583.963.067 1.47.988 1.47.988.855 1.465 2.243 1.042 2.79.797.086-.62.334-1.043.608-1.282-2.13-.243-4.367-1.065-4.367-4.738a3.71 3.71 0 01.987-2.573c-.1-.242-.427-1.217.093-2.537 0 0 .805-.258 2.637.982a9.203 9.203 0 012.4-.322c.814.003 1.635.11 2.401.322 1.83-1.24 2.634-.982 2.634-.982.522 1.32.194 2.295.094 2.537.615.671.987 1.526.987 2.573 0 3.682-2.243 4.493-4.378 4.73.344.298.65.881.65 1.775 0 1.283-.01 2.315-.01 2.631 0 .256.172.554.658.46a9.588 9.588 0 006.55-9.095 9.587 9.587 0 00-9.586-9.587"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/Github.aca7fa88.svg";
export { ForwardRef as ReactComponent };